import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { EXPERIENCE_DATA } from '../../constants';
import content from '../../i18n/content';
import './About.css';

function renderParagraph(text) {
  const slashInMatch = text.match(/<slashin>(.*?)<\/slashin>/);
  if (!slashInMatch) return text;

  const [full, label] = slashInMatch;
  const [before, after] = text.split(full);
  const url = EXPERIENCE_DATA.find((item) => item.id === 'slash-in')?.url;

  return (
    <>
      {before}
      <a href={url} target="_blank" rel="noopener noreferrer" className="about-inline-link">
        {label}
      </a>
      {after}
    </>
  );
}

export default function About() {
  const { lang } = useLanguage();
  const t = content[lang].about;

  return (
    <section id="about" className="about-section">
      <p className="about-eyebrow">{t.eyebrow}</p>
      <h2>{t.sectionTitle}</h2>
      <div className="about-body">
        {t.paragraphs.map((paragraph, index) => (
          <p key={index}>{renderParagraph(paragraph)}</p>
        ))}
      </div>
    </section>
  );
}
